import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import TemplateParameter from '../ManageCalibrationPatternTemplateParameter/ManageCalibrationPatternTemplateParameter.vue'
import FormatDate from '../../../../../Utils/FormatDate'

export default {
  props: {
    patternTemplateId: String,
  },

  components: {
    TemplateParameter,
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getStandardEquipment()

    if (this.patternTemplateId) {
      this.getPatternTemplate()
    }
  },

  data: () => ({
    expanded: [],
    totalItensOnPage: 0,
    step: 0,
    errorMessage: '',
    successMessage: '',
    newParameter: false,
    loading: false,
    parameterLoading: false,
    standardEquipmentLoading: false,
    deleteLoading: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    parameterDialog: false,
    editParameterDialog: false,
    deleteParameterDialog: false,
    dialogKey: false,
    showSuccess: false,
    institutionId: null,
    search: null,
    standardEquipmentSelected: [],
    standardEquipment: [],
    currentTemplateParameter: {},
    templateParameters: [],
    currentCalibrationPatternTemplate: {
      id: 0,
      name: '',
    },
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    filter: {
      page: 1,
      pageSize: 10,
      calibrationPatternTemplateId: null,
    },
    nameRules: [
      (v) => !!v || 'Padrão é requerido',
      (v) =>
        (v && v.length <= 128) || 'Padrão deve ter no máximo 128 caracteres',
    ],
    apiService: new ApiService(),
    generalService: new GeneralService(),
    parameterHeaders: [
      {
        text: 'Número',
        align: 'center',
        value: 'calibrationPattern.serialNumber',
      },
      {
        text: 'Padrão',
        align: 'center',
        value: 'calibrationPatternName',
      },
      {
        text: 'Validade',
        align: 'center',
        value: 'calibrationPattern.certifiedValidate',
      },
      {
        text: 'PARAM.',
        align: 'center',
        value: 'name',
        sortable: false,
      },
      {
        text: 'Métrica',
        align: 'center',

        value: 'metric',
      },
      {
        text: 'Tolerância',
        align: 'center',

        value: 'tolerance',
        sortable: false,
      },
      {
        text: 'Total Faixas',
        align: 'center',

        value: 'ranges',
        sortable: false,
      },
      {
        text: 'Ações',

        value: 'actions',
        align: null,
        sortable: false,
      },
    ],
    parameterHeadersMobile: [
      {
        text: 'Padrão',
        align: 'center',

        value: 'calibrationPatternName',
      },
      {
        text: 'Métrica',
        align: 'center',

        value: 'metric',
      },
      {
        text: 'Ações',
        align: 'center',

        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
  }),

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    formatDate(date) {
      return FormatDate.moment(date)
    },

    close() {
      sessionStorage.clear()
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push('/calibration?tab=template')
      }
    },

    closeDialog() {
      if (this.parameterDialog || this.editParameterDialog) {
        this.parameterDialog = false
        this.editParameterDialog = false
        this.updateParametersTable()
      } else {
        this.changedData = false
        this.close()
      }
    },

    addParameter() {
      if (this.$refs.firstForm.validate()) {
        this.newParameter = true
        this.submit()
      }
    },

    editParameter(parameter) {
      this.currentTemplateParameter = parameter
      this.editParameterDialog = true
      this.dialogKey = !this.dialogKey
    },

    deleteParameter(parameter) {
      this.currentTemplateParameter = parameter
      this.deleteParameterDialog = true
      this.dialogKey = !this.dialogKey
    },

    removeStandardEquipment(item) {
      this.standardEquipmentSelected.splice(
        this.standardEquipmentSelected.indexOf(item),
        1
      )
      this.standardEquipmentSelected = [...this.standardEquipmentSelected]
    },

    showSuccessAlert(message) {
      this.successMessage = message
      this.alienateDialog = false

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
        this.closeDialog()
      }, 2000)
    },

    async getPatternTemplate() {
      await this.apiService
        .get(
          `calibrationPatternTemplate/${this.institutionId}/${this.patternTemplateId}`
        )
        .then((response) => {
          this.currentCalibrationPatternTemplate = response.content
          this.filter.calibrationPatternTemplateId = response.content.id

          this.standardEquipmentSelected =
            response.content.calibrationPatternTemplateStandardEquipment.map(
              (templateEquipment) => templateEquipment
            )
          this.updateParametersTable()

          this.isEditing = true
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.go(-1)
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipment =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    async updateParametersTable() {
      this.parameterLoading = true

      this.filter.calibrationPatternTemplateId =
        this.currentCalibrationPatternTemplate.id

      await this.apiService
        .post('calibrationPatternTemplateParameter/list', this.filter)
        .then((response) => {
          this.templateParameters = response.content
          this.parameterLoading = false
        })
    },

    async submit() {
      this.loading = true

      if (this.$refs.firstForm.validate()) {
        const calibrationPatternTemplate = {
          Id: this.currentCalibrationPatternTemplate.id,
          Name: this.currentCalibrationPatternTemplate.name,
          InstitutionId: this.institutionId,
          StandardEquipments: this.standardEquipmentSelected
            .filter((x) => !!x.standardEquipment)
            .map((x) => x.standardEquipment),
        }

        let url = 'calibrationPatternTemplate/add'

        if (this.isEditing) {
          url = 'calibrationPatternTemplate/edit'
        }

        await this.apiService
          .post(url, calibrationPatternTemplate)
          .then((response) => {
            this.currentCalibrationPatternTemplate = response.content

            if (this.newParameter && this.currentCalibrationPatternTemplate) {
              this.parameterDialog = true
              this.dialogKey = !this.dialogKey
              this.isEditing = true
              this.newParameter = false
            } else {
              this.closeDialog()
            }
          })
          .catch((err) => {
            window.scrollTo(0, 0)
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

        this.loading = false
        this.changedData = false
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
      this.loading = false
    },

    async removeParameter() {
      this.deleteLoading = true

      await this.apiService
        .delete(
          'calibrationPatternTemplateParameter/delete',
          this.currentTemplateParameter
        )
        .then(() => {
          this.deleteLoading = false
          this.deleteParameterDialog = false
          this.updateParametersTable()
        })
        .catch(() => {
          this.deleteLoading = false
          this.deleteParameterDialog = false
        })
    },
  },

  watch: {
    currentCalibrationPatternTemplate: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateParametersTableTable()
    },

    page() {
      this.filter.page = this.page
      this.updateParametersTableTable()
    },

    standardEquipmentSelected() {
      this.search = ''
    },
  },
}
